//FILTRO PELO TIPO DE USUÁRIO
import { FaFilter } from "react-icons/fa";
import "./ProfileFilter.css";

const ProfileFilter = ({ selectedProfiles, handleProfileFilter }) => {
  return (
    <div className="profile-filter-container">
      <div className="profile-filter-label">
        <FaFilter className="filter-icon" />
        <span>Perfil</span>
      </div>
      <div className="profile-filter-options">
        {["Analista", "Administrador", "Sindicato"].map((profile) => (
          <label key={profile} className="filter-option">
            <input
              type="checkbox"
              checked={selectedProfiles.includes(profile)}
              onChange={() => handleProfileFilter(profile)}
            />
            {profile}
          </label>
        ))}
      </div>
    </div>
  );
};

export default ProfileFilter;
